// removed by extract-text-webpack-plugin
module.exports = {"info-field":"info-field"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/InfoField/InfoField.scss
// module id = H8dy
// module chunks = 0